import React from 'react';
export function Footer() {
  return <footer className="bg-black px-5 py-10 text-center sm:px-8" data-id="element-60" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-3xl space-y-3 text-[12px] leading-relaxed text-neutral-400" data-id="element-61" data-mp="3gfiswe27a3c0">
        <p className="font-display text-[15px] text-neutral-200" data-id="element-62" data-mp="32onjn0nshk7w">
          Manual de Autosanación Energética
        </p>
        <nav className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1" data-id="element-63" data-mp="36q900vzj8gmu">
          <a href="#privacidad" className="transition-colors duration-200 ease-out hover:text-gold" data-id="element-64" data-mp="3ug3gromz2pcd">
            Política de Privacidad
          </a>
          <span aria-hidden="true" className="text-neutral-700" data-id="element-65" data-mp="36d26u3xsnlq">|</span>
          <a href="#terminos" className="transition-colors duration-200 ease-out hover:text-gold" data-id="element-66" data-mp="3ldu8l5f6f825">
            Términos
          </a>
          <span aria-hidden="true" className="text-neutral-700" data-id="element-67" data-mp="29z6v4e3aingy">|</span>
          <a href="#contacto" className="transition-colors duration-200 ease-out hover:text-gold" data-id="element-68" data-mp="29xvqkc20tbos">
            Contacto
          </a>
        </nav>
        <p className="text-neutral-500" data-id="element-69" data-mp="3l90nfv0aswyq">
          Producto educativo e informativo. No sustituye diagnóstico ni tratamiento médico
          profesional. Los resultados individuales pueden variar.
        </p>
        <p className="text-neutral-600" data-id="element-70" data-mp="3v7zvbbd8ooko">© 2025 Todos los derechos reservados.</p>
      </div>
    </footer>;
}